export const raFabTheme = {
    styleOverrides: {
        root: {
            marginBottom: '20px !important',
        },
    },
};
